import { jsx as _jsx } from "react/jsx-runtime";
var Routes = function Routes(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 4c-.5523 0-1 .44772-1 1s.4477 1 1 1 1-.44772 1-1-.4477-1-1-1Zm-3 1c0-1.65685 1.3431-3 3-3s3 1.34315 3 3-1.3431 3-3 3-3-1.34315-3-3ZM6 18c-.55228 0-1 .4477-1 1s.44772 1 1 1 1-.4477 1-1-.44772-1-1-1Zm-3 1c0-1.6569 1.34315-3 3-3s3 1.3431 3 3-1.34315 3-3 3-3-1.3431-3-3ZM6.73223 6.73223C7.20107 6.26339 7.83696 6 8.5 6H12c.5523 0 1-.44772 1-1s-.4477-1-1-1H8.5c-1.19347 0-2.33807.47411-3.18198 1.31802C4.47411 6.16193 4 7.30653 4 8.5c0 1.19347.47411 2.3381 1.31802 3.182C6.16193 12.5259 7.30653 13 8.5 13h8c.663 0 1.2989.2634 1.7678.7322.4688.4689.7322 1.1048.7322 1.7678s-.2634 1.2989-.7322 1.7678C17.7989 17.7366 17.163 18 16.5 18H12c-.5523 0-1 .4477-1 1s.4477 1 1 1h4.5c1.1935 0 2.3381-.4741 3.182-1.318C20.5259 17.8381 21 16.6935 21 15.5s-.4741-2.3381-1.318-3.182C18.8381 11.4741 17.6935 11 16.5 11h-8c-.66304 0-1.29893-.2634-1.76777-.7322C6.26339 9.79893 6 9.16304 6 8.5c0-.66304.26339-1.29893.73223-1.76777Z",
      fill: color
    })
  });
};
export default Routes;